<template>
  <div>
    <nav
      id="navbar-scrollable"
      class="navbar md-down-fixed-top navbar-expand-md navbar-light bg-body pt-4 d-flex flex-column align-items-center"
    >
      <div class="container" style="height: 100%">
        <a class="navbar-brand d-flex flex-row align-items-center" href="/">
          <img :src="logoImage" class="d-inline-block align-top" alt />
          <span class="mobileHide" v-if="$store.state.campaign !== undefined">{{$store.state.campaign.name}}</span>
        </a>
        <div class="d-none d-md-flex">
          <ul class="navbar-nav ml-auto d-flex align-items-center">
            <template v-if="$route !== undefined && $route.name !== 'banned'">
              <li class="nav-item">
                <router-link class="nav-link" to="/dashboard">{{$t('tenants.home')}}</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/actions">{{$t('tenants.setting.myactions')}}</router-link>
              </li>
              <li class="nav-item" v-if="this.$store.state.campaign.show_leaderboard">
                <router-link class="nav-link" to="/leaderboard">{{$t('tenants.leaderboard')}}</router-link>
              </li>

              <li class="nav-item" v-if="this.$store.state.campaign.show_catalog">
                <router-link class="nav-link" to="/catalog">{{$t('tenants.catalog')}}</router-link>
              </li>

              <li class="nav-item">
                <router-link class="nav-link" to="/code">{{$t('tenants.insertcode')}}</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/settings/profile">{{$t('Profile')}}</router-link>
              </li>

              <li v-if="$store.state.campaign.mgm_enabled" class="nav-item ml-3">
                <button
                  class="btn btn-primary btn-sm text-uppercase"
                  @click="$router.push('/invite')"
                >{{$t('Invite friends')}}</button>
              </li>
            </template>

            <li class="nav-item">
              <a class="nav-link">
                <div
                  v-html="iconLogout"
                  @click="$store.dispatch('logout'); $router.push('/')"
                  class="ml-4 f-icon"
                  style="line-height:1px;width:30px;cursor: pointer"
                ></div>
              </a>
            </li>
          </ul>
        </div>
        <div class="d-flex d-md-none">
          <ul class="navbar-nav ml-auto d-flex">
            <router-link class="nav-item nav-link" to="/settings">
              <i class="fal fa-cog" style="font-size: 1.5rem;"></i>
            </router-link>
          </ul>
        </div>
      </div>
    </nav>
    <template v-if="$route.name !== 'banned'">
      <nav class="nav nav-pills nav-fill fixed-bottom d-md-none w-100 flex-nowrap" id="bottomBar">
        <router-link to="/dashboard" class="nav-item nav-link">
          <i class="fal fa-home"></i>
          {{$t('tenants.home')}}
        </router-link>
        <router-link to="/leaderboard" class="nav-item nav-link">
          <i class="fal fa-chart-bar"></i>
          {{$t('tenants.leaderboard')}}
        </router-link>
        <router-link to="/catalog" class="nav-item nav-link" v-if="this.$store.state.campaign.show_catalog">
          <i class="fal fa-tags"></i>
          {{$t('tenants.catalog')}}
        </router-link>
        <router-link to="/code" class="nav-item nav-link">
          <i class="fal fa-qrcode"></i>
          {{$t('tenants.insertcode')}}
        </router-link>

        <router-link v-if="$store.state.campaign.mgm_enabled" to="/invite" class="nav-item nav-link">
          <div v-html="iconMgm" style="line-height:1px;"></div>
          {{$t('Invite')}}
        </router-link>
      </nav>
    </template>
    <template v-else>
      <nav class="nav nav-pills nav-fill fixed-bottom d-md-none w-100 flex-nowrap" id="bottomBar">
        <li class="nav-item">
          <a class="nav-link">
            <div
              v-html="iconLogout"
              @click="$store.dispatch('logout'); $router.push('/')"
              class="ml-4 f-icon"
              style="line-height:1px;width:30px;cursor: pointer"
            ></div>
          </a>
        </li>
      </nav>
    </template>
  </div>
</template>
<script>
import iconLogout from "./../assets/svg/fnz_logout.svg";
import iconMgm from "./../assets/svg/fnz_mgm.svg";

export default {
  name: "navigation",
  data: function() {
    return {
      iconLogout: iconLogout,
      iconMgm: iconMgm
    };
  },
  components: {
    iconLogout,
    iconMgm
  },
  computed: {
    logoImage() {
      return (
        window.location.protocol +
        "//" +
        window.location.host +
        "/" +
        this.$store.getters.getBrandLogo
      );
    }
  },
  created() {
    window.prevScrollpos = window.pageYOffset;
    window.onscroll = function() {
      let currentScrollPos = window.pageYOffset;
      const navbarScrollable = document.getElementById("navbar-scrollable");
      if (window.prevScrollpos > currentScrollPos && navbarScrollable) {
        navbarScrollable.classList.remove("scroll");
      } else if (navbarScrollable && currentScrollPos > 0) {
        navbarScrollable.classList.add("scroll");
      }
      window.prevScrollpos = currentScrollPos;
    };
  }
};
</script>
<style>
.router-link-active {
  font-weight: bold !important;
  color: rgba(0, 0, 0, 0.9) !important;
}
#bottomBar svg {
  max-height: 30px;
}

@media (max-width: 991.98px) {
  .navbar.md-down-fixed-top.scroll {
    top: -100px;
  }
}
</style>